// extracted by mini-css-extract-plugin
export var menuIcon = "_tl-0";
export var menuIconInline = "_tl-1";